
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Action, refundApprove } from '../Model/refundApprove';
import { chaseRefundProcessInput } from "../Model/chaseRefundProcessInput";
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class RefundApproveService {
  private baseUrl: string;
  RefundDetailID: any;
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
   //this.baseUrl = "http://localhost:56375";
   //this.baseUrl = "https://Invoiceservice.devusz.nbcuni.com";
   //this.baseUrl = "https://InvoiceserviceQA.devusz.nbcuni.com";
   this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
    
  }

  //Method to get the Action List
  getActionList(): Observable<any[]> {
    //debugger;
    //return this.http.get("assets/data/InternalUser.json")
    return this.http.get(this.baseUrl + `/api/getActionList`).pipe(
      map((response: any) => response as Action[]),
      catchError(handleError),);
  }

  //Method to get the Refund Details
  getRefundDetails(UserID): Observable<any[]> {
    debugger;
    //return this.http.get("assets/data/InternalUser.json")
    return this.http.get(this.baseUrl + `/api/getRefundDetails/`+UserID).pipe(
      map((response: any) => response as any[]),
      catchError(handleError),);
  }

  submitActionDetails(updatedRefundDetails:any): Observable<any> {
    //debugger;

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post(this.baseUrl + `/api/submitAction`, JSON.stringify(updatedRefundDetails), options).pipe(
    //return this.http.post(this.baseUrl + `/api/submitAction/`+ApprovalStatus+`/`+RefundApproved + `/`+comments+ );
      map((response: any) => response as any)); 
  }

  getChaseRefundStatus(chaseOrderId: string): Observable<any> {

  return this.http.get(this.baseUrl + `/api/getChaseRefundStatus/` + chaseOrderId).pipe(
      map((response: any) => response),
      catchError(handleError),);
}

  postRefund(dataXML : string) {

    var body = dataXML;
    var headerOptions = new HttpHeaders({
      'Content-Type': 'application/PTI70',
      'mime-version': '1.0',
      'Content-transfer-encoding': 'text',
      'Request-number': '1',
      'Document-type': 'Request',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
      'Access-Control-Allow-Headers': 'Content-Type, Accept',
      'Access-Control-Max-Age': '1728000',
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*'
    });
    return this.http.post('https://orbitalvar2.chasepaymentech.com/authorize', body, { headers: headerOptions }).pipe(map(data => {
      let result = data; // Assuming 'data' is the response you want to assign to 'result'
      return result;}
      , error => {
        let result= error.text();
        console.log("ERROR: ", error);
      return result;
      }
    ));

  }

getChaseRefundRequestData(refundDetailId: string): Observable<any> {

  return this.http.get(this.baseUrl + `/api/getChaseRefundRequestData/` + refundDetailId).pipe(
      map((response: any) => response),
      catchError(handleError),);

}  

processChaseRefundResponse(refundDetailId: string, processInput: chaseRefundProcessInput): Observable<any> {

  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  return this.http.post(this.baseUrl + `/api/processChaseRefundResponse/` + refundDetailId, JSON.stringify(processInput), { headers }).pipe(
  map((response: any) => response));

} 

}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``
  console.error(errorMsg);

  // throw an application level error
  return observableThrowError(errorMsg);
}